import store from '@/store';
import axios from 'axios';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import moment from 'moment';
import OrderLine from '@/ts/OrderLine';
import Transaction from '@/ts/Transaction';
import Order from '@/ts/Order';
import BalanceAccountItem from '@/ts/BalanceAccountItem';
import Refund from '@/ts/store/Refund';

@Module({name: 'UnitFinance', namespaced: true})
export default class UnitFinance extends VuexModule {
    public pauseAutomaticChargingOverlayVisibility: boolean = false;
    public startAutomaticChargingOverlayVisibility: boolean = false;
    public automaticRentIncreaseOverlayVisibility: boolean = false;
    public selectedAutomaticCharging: any = null;
    public intervalsOptions: any = [];
    public typeOptions: any = [];

    public chargesFormComponent: string = 'UnitFinanceChargesForm';
    public chargesTableComponent: string = 'UnitFinanceChargesTable';

    public refundFormComponent: string = 'UnitFinanceRefundForm';
    public refundTableComponent: string = 'UnitFinanceRefundTable';

    public fixedChargesFormComponent: string = 'UnitFinanceFixedChargesForm';
    public fixedChargesTableComponent: string = 'UnitFinanceFixedChargesTable';

    public consumptionAccountsFormComponent: string = 'UnitFinanceConsumptionAccountsForm';
    public consumptionAccountsTableComponent: string = 'UnitFinanceConsumptionAccountsTable';


    public chargesEditFormComponent: string = 'UnitFinancePeriodicalChargesEditForm';

    public chargesComponent: string = '';
    public refundComponent: string = '';
    public fixedChargesComponent: string = '';
    public consumptionAccountsComponent: string = '';

    public chargesFormMode: string = 'periodical';
    public chargesTableCurrentTab: number = 1;

    // Data
    /* Naming can be changed: Kontokort */
    public creditsData: Transaction[] = [];
    public creditsOrderLinesData: OrderLine[] = [];
    public balanceAccountItems: BalanceAccountItem[] = [];

    /* Naming can be changed: Faste opkrævninger */
    public periodicalChargesData: any = [];

    /* Naming can be changed: Engangsopkrævninger */
    public oneTimeChargesData: Order[] = [];

    /* Naming can be changed: Tilbagebetaling */
    public refundsData: any = [];

    /* Naming can be changed: Finansbilag */
    public fixedChargesData: any = [];

    /* Naming can be changed: Forbrugsregnskab */
    public consumptionAccountsData: any = [];

    public arrears: number = 0;
    public currencies: [] = [];
    public paymentProviders: [] = [];
    public orders: Order[] = [];
    public refundableOrders: Order[] = [];

    public activePeriodicalOrder: [] = [];

    get getPauseAutomaticChargingOverlayVisibility(): boolean {
        return this.pauseAutomaticChargingOverlayVisibility;
    }

    get getStartAutomaticChargingOverlayVisibility(): boolean {
        return this.startAutomaticChargingOverlayVisibility;
    }

    get getAutomaticRentIncreaseOverlayVisibility(): boolean {
        return this.automaticRentIncreaseOverlayVisibility;
    }

    get getSelectedAutomaticCharging(): boolean {
        return this.selectedAutomaticCharging;
    }

    get getCreditsData(): Transaction[] {
        return this.creditsData;
    }

    get getCreditsOrderLinesData(): OrderLine[] {
        return this.creditsOrderLinesData;
    }

    get getBalanceAccountData(): BalanceAccountItem[] {
        return this.balanceAccountItems;
    }

    get getPeriodicalChargesDataData(): any {
        return this.periodicalChargesData;
    }

    get getRefundsData(): any {
        return this.refundsData;
    }

    get getFixedChargesData(): any {
        return this.fixedChargesData;
    }

    get getConsumptionAccountsData(): any {
        return this.consumptionAccountsData;
    }




    get getChargesFormComponent(): string {
        return this.chargesFormComponent;
    }

    get getChargesEditFormComponent(): string {
        return this.chargesEditFormComponent;
    }

    get getActivePeriodicalOrder(): [] {
        return this.activePeriodicalOrder;
    }

    get getChargesTableComponent(): string {
        return this.chargesTableComponent;
    }

    get getRefundFormComponent(): string {
        return this.refundFormComponent;
    }

    get getRefundTableComponent(): string {
        return this.refundTableComponent;
    }

    get getFixedChargesFormComponent(): string {
        return this.fixedChargesFormComponent;
    }

    get getFixedChargesTableComponent(): string {
        return this.fixedChargesTableComponent;
    }

    get getConsumptionAccountsFormComponent(): string {
        return this.consumptionAccountsFormComponent;
    }

    get getConsumptionAccountsTableComponent(): string {
        return this.consumptionAccountsTableComponent;
    }

    get getChargesFormMode(): string {
        return this.chargesFormMode;
    }

    get getChargesTableCurrentTab(): number {
        return this.chargesTableCurrentTab;
    }

    get getChangesComponent(): string {
        return this.chargesComponent;
    }

    get getRefundComponent(): string {
        return this.refundComponent;
    }

    get getFixedChargesComponent(): string {
        return this.fixedChargesComponent;
    }

    get getConsumptionAccountsComponent(): string {
        return this.consumptionAccountsComponent;
    }

    get getIntervals(): string {
        return this.intervalsOptions;
    }

    get getTypeOptions(): string {
        return this.typeOptions;
    }

    get getArrears(): number {
        return this.arrears;
    }

    get getCurrencies(): any {
        return this.currencies;
    }

    get getPaymentProviders(): any {
        return this.paymentProviders;
    }

    get getOrders(): Order[] {
        return this.orders;
    }

    get getRefundableOrders(): Order[] {
        return this.refundableOrders;
    }

    @Mutation
    public SET_CURRENCIES(data: any) {
        this.currencies = data;
    }

    @Mutation
    public SET_PAYMENT_PROVIDERS(data: any) {
        this.paymentProviders = data;
    }

    @Mutation
    public SET_SELECTED_AUTOMATIC_CHARGING(charging: any): void {
        this.selectedAutomaticCharging = charging;
    }

    @Mutation
    public SET_PAUSE_AUTOMATIC_CHARGING_OVERLAY_VISIBILITY(visibility: boolean): void {
        this.pauseAutomaticChargingOverlayVisibility = visibility;
    }

    @Mutation
    public SET_START_AUTOMATIC_CHARGING_OVERLAY_VISIBILITY(visibility: boolean): void {
        this.startAutomaticChargingOverlayVisibility = visibility;
    }

    @Mutation
    public SET_AUTOMATIC_RENT_INCREASE_OVERLAY_VISIBILITY(visibility: boolean): void {
        this.automaticRentIncreaseOverlayVisibility = visibility;
    }

    @Mutation
    public SET_CHARGES_COMPONENT(component: string): void {
        this.chargesComponent = component;
    }

    @Mutation
    public SET_REFUND_COMPONENT(component: string): void {
        this.refundComponent = component;
    }

    @Mutation
    public SET_FIXED_CHARGES_COMPONENT(component: string): void {
        this.fixedChargesComponent = component;
    }

    @Mutation
    public SET_CONSUMPTION_ACCOUNTS_COMPONENT(component: string): void {
        this.consumptionAccountsComponent = component;
    }

    @Mutation
    public SET_CHARGES_FORM_MODE(component: string): void {
        this.chargesFormMode = component;
    }

    @Mutation
    public SET_CHARGES_TABLE_CURRENT_TAB(tabIndex: number): void {
        this.chargesTableCurrentTab = tabIndex;
    }

    @Mutation
    public SET_CREDITS_FINANCE_DATA(credits: any): void {
        this.creditsData = [];
        for (const credit of credits) {
            this.creditsData.push(new Transaction(
                credit.externalId,
                credit.date,
                credit.orderDate,
                credit.orderType,
                credit.orderId,
                credit.orderAmount,
                credit.unitId,
                credit.unitTitle,
                credit.unitAddress,
                credit.additionalData,
                credit.orderDescription,
                credit.paymentMethod,
                credit.paymentStatus,
                credit.currency,
                credit.tenantName,
                credit.tenantId,
                credit.project,
            ));
        }
    }

    @Mutation
    public SET_CREDITS_ORDER_LINES_DATA(credits: any): void {
        this.creditsOrderLinesData = [];
        for (const credit of credits) {
            this.creditsOrderLinesData.push(new OrderLine(
                credit.date,
                credit.type,
                credit.amount,
                credit.vat_amount,
                credit.total_amount,
                credit.order,
                credit.status,
            ));
        }
    }

    @Mutation
    public SET_BALANCE_ACCOUNT_DATA(data: any): void {
        this.balanceAccountItems = [];
        for (const balanceItem of data) {

            this.balanceAccountItems.push(new BalanceAccountItem(
                balanceItem.date,
                balanceItem.type,
                balanceItem.amount,
                balanceItem.balance,
                balanceItem.orderId,
                balanceItem.status,
                balanceItem.rowType,
                ));
        }
    }

    @Mutation
    public SET_PERIODICAL_CHARGES_FINANCE_DATA(periodicalCharges: any): void {
        this.periodicalChargesData = periodicalCharges;
    }

    @Mutation
    public SET_ACTIVE_PERIODICAL_CHARGE_FINANCE_DATA(id: string): void {
        this.activePeriodicalOrder = this.periodicalChargesData.find((periodicalOrder: any) => periodicalOrder.id === id);
    }

    @Mutation
    public SET_ONE_TIME_CHARGES_FINANCE_DATA(oneTimeCharges: any): void {
        this.oneTimeChargesData = oneTimeCharges;
    }

    @Mutation
    public SET_REFUNDS_FINANCE_DATA(refunds: any): void {
        this.refundsData = [];
        for (const refund of refunds) {
            this.refundsData.push(new Refund(
                refund.id,
                refund.orderId,
                refund.totalAmount,
                refund.status,
                refund.refundDate,
                refund.completedDate,
            ));
        }
    }

    @Mutation
    public SET_FIXED_CHARGES_FINANCE_DATA(data: any): void {
        this.fixedChargesData = data;
    }

    @Mutation
    public SET_CONSUMPTION_ACCOUNTS_FINANCE_DATA(accountsData: any): void {
        this.consumptionAccountsData = accountsData;
    }


    @Mutation
    public ADD_PERIODICAL_CHARGE_DATA(data: any): void {
        this.periodicalChargesData.push(data);
    }

    @Mutation
    public REMOVE_PERIODICAL_CHARGE_DATA(id: number): void {
        this.periodicalChargesData = this.periodicalChargesData.filter((data: any) => data.id !== id);
    }

    @Mutation
    public REMOVE_ONE_TIME_CHARGE_DATA(id: number): void {
        this.orders = this.orders.filter((data: any) => data.id !== id);
    }

    @Mutation
    public ADD_ONE_TIME_CHARGE_DATA(data: any): void {
            for (const order of data) {
                const orderLines = [];
                for (const orderLine of order.orderLines) {
                    orderLines.push(new OrderLine(
                        orderLine.date,
                        orderLine.type,
                        orderLine.amount,
                        orderLine.vat_amount,
                        orderLine.total_amount,
                        orderLine.order,
                        orderLine.status,
                    ));
                }

                this.orders.push(new Order(
                    order.id,
                    order.unit_id,
                    order.address,
                    order.date,
                    order.amount,
                    order.vat_amount,
                    order.total_amount,
                    order.project,
                    order.unit,
                    order.days_overdue,
                    order.description,
                    order.tenant_type,
                    order.payment_date ? order.payment_date : null,
                    order.type,
                    order.status,
                    order.isAutopaid,
                    '',
                    '',
                    orderLines,
                    order.completetedRefundsAmount,
                    order.pendingRefundsAmount,
                    order.remainingAmount,
                ));
            }
    }

    @Mutation
    public ADD_REFUND_CHARGE_DATA(data: any): void {
        this.refundsData.push(data);
    }

    @Mutation
    public ADD_FIXED_CHARGE_DATA(data: any): void {
        this.fixedChargesData.push(data);
    }

    @Mutation
    public ADD_CONSUMPTION_ACCOUNT_DATA(data: any): void {
        this.consumptionAccountsData.push(data);
    }

    @Mutation
    public SET_PERIODICAL_CHARGE_PAUSE_STATUS(chargePayload: any): void {
        const activeCharge  = this.periodicalChargesData.find((charge: any) => charge.id  === chargePayload.id);
        activeCharge.status = 'pause';
        activeCharge.active = 0;
    }

    @Mutation
    public SET_PERIODICAL_CHARGE_START_STATUS(chargePayload: any): void {
        const activeCharge  = this.periodicalChargesData.find((charge: any) => charge.id  === chargePayload.id);
        activeCharge.status = 'active';
        activeCharge.active = 1;
    }


    @Mutation
    public RESET_UNIT_FINANCE_STORE_STATE(): void {
        this.fixedChargesComponent = '';
        this.consumptionAccountsComponent = '';
        this.chargesFormMode = 'periodical';
        this.chargesComponent = '';
        this.chargesTableCurrentTab = 1;
    }

    @Mutation
    public SET_INTERVALS(data: any): void {
        this.intervalsOptions = data;
    }

    @Mutation
    public SET_PAYMENT_ORDER_LINE_TYPES(data: any): void {
        this.typeOptions = data;
    }


    @Mutation
    public SET_UNIT_ARREARS(data: any): void {
        this.arrears = data;
    }

    @Mutation
    public UPDATE_UNIT_ARREAR(newArrearAmount: number): void {
        this.arrears += newArrearAmount;
    }

    @Mutation
    public SET_UNIT_ORDERS(data: any): void {
        this.orders = [];
        for (const order of data) {
            const orderLines = [];
            for (const orderLine of order.orderLines) {
                orderLines.push(new OrderLine(
                    orderLine.date,
                    orderLine.type,
                    orderLine.amount,
                    orderLine.vat_amount,
                    orderLine.total_amount,
                    orderLine.order,
                    orderLine.status,
                ));
            }
            this.orders.push(new Order(
                order.id,
                order.unit_id,
                order.address,
                order.date,
                order.amount,
                order.vat_amount,
                order.total_amount,
                order.project,
                order.unit,
                order.days_overdue,
                order.description,
                order.tenant_type,
                order.payment_date ? order.payment_date : null,
                order.type,
                order.status,
                order.isAutopaid,
                '',
                '',
                orderLines,
                order.completedRefundsAmount,
                order.pendingRefundsAmount,
                order.remainingAmount,
            ));
        }
    }

    @Mutation
    public SET_UNIT_REFUNDABLE_ORDERS(data: any): void {
        this.refundableOrders = [];
        for (const order of data) {
            const orderLines = [];
            for (const orderLine of order.orderLines) {
                orderLines.push(new OrderLine(
                    orderLine.date,
                    orderLine.type,
                    orderLine.amount,
                    orderLine.vat_amount,
                    orderLine.total_amount,
                    orderLine.order,
                    orderLine.status,
                ));
            }
            this.refundableOrders.push(new Order(
                order.id,
                order.unit_id,
                order.address,
                order.date,
                order.amount,
                order.vat_amount,
                order.total_amount,
                order.project,
                order.unit,
                order.days_overdue,
                order.description,
                order.tenant_type,
                order.payment_date ? order.payment_date : null,
                order.type,
                order.status,
                order.isAutopaid,
                '',
                '',
                orderLines,
                order.completedRefundsAmount,
                order.pendingRefundsAmount,
                order.remainingAmount,
            ));
        }
    }


    @Mutation
    public SET_PERIODICAL_CHARGE_DATA(periodicalOrderData: any) {
        const index = this.periodicalChargesData.findIndex((charge: any) => charge.id === periodicalOrderData.id);
        this.periodicalChargesData[index] = periodicalOrderData;
    }

    @Action
    public FETCH_CREDITS_FINANCE_DATA(unitId: number): void {

        axios.get(Endpoints.Admin.Finances.FETCH_CREDITS_FINANCE_DATA(unitId))
            .then((response) => {
                store.commit(Mutations.SET_CREDITS_FINANCE_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_UNIT_ORDER_LINES(unitId: number): void {
        axios.get(Endpoints.Admin.Finances.FETCH_UNIT_ORDER_LINES(unitId))
            .then((response) => {
                store.commit(Mutations.SET_CREDITS_ORDER_LINES_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_UNIT_BALANCE_ACCOUNT_DATA(unitId: number): void {
        axios.get(Endpoints.Admin.Finances.FETCH_UNIT_BALANCE_ACCOUNT_DATA(unitId))
            .then((response) => {
                store.commit(Mutations.SET_BALANCE_ACCOUNT_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_PERIODICAL_CHARGES_FINANCE_DATA(unitId: number): void {

        axios.get(Endpoints.Admin.Finances.FETCH_PERIODICAL_CHARGES_FINANCE_DATA(unitId))
            .then((response) => {
                store.commit(Mutations.SET_PERIODICAL_CHARGES_FINANCE_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_ONE_TIME_CHARGES_FINANCE_DATA(): void {
    }

    @Action
    public FETCH_REFUNDS_FINANCE_DATA(unitId: number): void {
        axios.get(Endpoints.Admin.Finances.FETCH_REFUNDS_FINANCE_DATA(unitId))
            .then((response) => {
                store.commit(Mutations.SET_REFUNDS_FINANCE_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });

    }

    @Action
    public FETCH_FIXED_CHARGES_FINANCE_DATA(): void {

        store.commit(Mutations.SET_FIXED_CHARGES_FINANCE_DATA, [
            {id: 1, paymentDate: '12-08-2020', amount: 12, charges: [
                {type: {title: 'Aconto varme'}, text: 'Husleje', amount: 12, vat: false, total: 12 },
            ]},
        ]);
    }

    @Action
    public FETCH_CONSUMPTION_ACCOUNTS_FINANCE_DATA(): void {

        store.commit(Mutations.SET_CONSUMPTION_ACCOUNTS_FINANCE_DATA, [
            {id: 1, type: {title: 'Aconto varme'}, created: '12-08-2020 - 10:22', periodStart: '12-08-2020', periodEnd: '12-08-2020', spending: 2000.00, paid: 2000.00, total: 'Skal have 400,00 DKK tilbage'},
        ]);
    }

    @Action
    public ADD_PERIODICAL_CHARGE(data: any): void {
        const requestPayload = {
            interval_id: data.form.interval.id,
            paymentDate: data.form.paymentDate,
            paymentEndDate: data.form.paymentEndDate,
            unit_id: data.unitId,
            order_lines: Array(),
        };

        data.form.charges.forEach((value: any,  index: any) => {
            requestPayload.order_lines.push({
                type_id: value.type.id,
                text: value.text,
                amount: value.amount,
                vat: value.vat,
            });
        });

        axios.post(Endpoints.Admin.Finances.ADD_RECURRING_ORDER, requestPayload)
            .then((response) => {
                store.commit(Mutations.ADD_PERIODICAL_CHARGE_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public REMOVE_PERIODICAL_CHARGE(id: string): void {

        axios.delete(Endpoints.Admin.Finances.REMOVE_PERIODICAL_CHARGE(id))
            .then((response) => {
                store.commit(Mutations.REMOVE_PERIODICAL_CHARGE_DATA, id);
                store.commit(Mutations.RESET_CONFIRM_POPUP_DATA);

            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });


    }

    @Action
    public ADD_ONE_TIME_CHARGE(data: any): Promise<any> {

        const requestPayload = {
            unit_id: data.unitId,
            order_lines: Array(),
            paymentDate: data.form.paymentDate,
        };

        data.form.charges.forEach((value: any,  index: any) => {
            requestPayload.order_lines.push({
                type_id: value.type.id,
                text: value.text,
                amount: value.amount,
                vat: value.vat,
            });
        });

        return new Promise((resolve, reject) => {
            axios.post(Endpoints.Admin.Finances.ADD_ONE_TIME_ORDER, requestPayload)
            .then((response) => {
                store.commit(Mutations.ADD_ONE_TIME_CHARGE_DATA, response.data);
                store.dispatch(Actions.FETCH_UNIT_ARREARS, data.unitId);
                resolve(response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
                reject(error);
            });
        });

    }

    @Action
    public REMOVE_ONE_TIME_CHARGE(id: string): void {

        axios.delete(Endpoints.Admin.Finances.REMOVE_ONE_TIME_CHARGE(id))
            .then((response) => {
                store.commit(Mutations.REMOVE_ONE_TIME_CHARGE_DATA, id);
                store.commit(Mutations.RESET_CONFIRM_POPUP_DATA);

            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });


    }


    @Action
    public ADD_REFUND_CHARGE(data: any): void {
        // TODO: make request to API

        store.commit(Mutations.ADD_REFUND_CHARGE_DATA, {
            id: UnitFinance.state.refundsData.length + 1,
            paymentDate: data.date,
            amount: data.charges.reduce((total: number, formObject: any) => Number(formObject.amount) + total, 0),
            charges: data.charges,
        });
    }

    @Action
    public ADD_FIXED_CHARGE(data: any): void {
        // TODO: make request to API

        store.commit(Mutations.ADD_FIXED_CHARGE_DATA, {
            id: UnitFinance.state.fixedChargesData.length + 1,
            paymentDate: moment().format('DD-MM-YYYY'),
            amount: data.reduce((total: number, formObject: any) => Number(formObject.amount) + total, 0),
            charges: data,
        });
    }

    @Action
    public ADD_CONSUMPTION_ACCOUNT(data: any): void {
        // TODO: make request to API

        store.commit(Mutations.ADD_CONSUMPTION_ACCOUNT_DATA, data);
    }

    @Action
    public PAUSE_PERIODICAL_CHARGE(data: any): void {
        axios.post(Endpoints.Admin.Finances.PAUSE_PERIODICAL_CHARGE(data.id), data)
            .then((response) => {
                store.commit(Mutations.SET_PERIODICAL_CHARGE_PAUSE_STATUS, data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public START_PERIODICAL_CHARGE(data: any): void {
        axios.post(Endpoints.Admin.Finances.START_PERIODICAL_CHARGE(data.id), data)
            .then((response) => {
                store.commit(Mutations.SET_PERIODICAL_CHARGE_START_STATUS, data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }


    @Action
    public UPDATE_PERIODICAL_CHARGE(data: any): void {
        axios.put(Endpoints.Admin.Finances.UPDATE_PERIODICAL_CHARGE(data.form.id), data.form)
            .then((response) => {
                store.commit(Mutations.SET_PERIODICAL_CHARGE_DATA, response.data);
                store.commit(Mutations.SET_CHARGES_TABLE_CURRENT_TAB, 1);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_INTERVALS(): void {
        axios.get(Endpoints.Admin.Finances.FETCH_INTERVALS)
            .then((response) => {
                store.commit(Mutations.SET_INTERVALS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_PAYMENT_ORDER_LINE_TYPES(): void {
        axios.get(Endpoints.Admin.Finances.FETCH_PAYMENT_ORDER_LINE_TYPES)
            .then((response) => {
                store.commit(Mutations.SET_PAYMENT_ORDER_LINE_TYPES, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_UNIT_ARREARS(unitId: number): void {
        axios.get(Endpoints.Admin.Finances.FETCH_UNIT_ARREARS(unitId))
            .then((response) => {
                store.commit(Mutations.SET_UNIT_ARREARS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }


    @Action
    public FETCH_CURRENCIES(data: any) {
        axios.get(Endpoints.Admin.Finances.FETCH_CURRENCIES)
            .then((response) => {
                store.commit(Mutations.SET_CURRENCIES, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_PAYMENT_PROVIDERS(data: any) {
        axios.get(Endpoints.Admin.Finances.FETCH_PAYMENT_PROVIDERS)
            .then((response) => {
                store.commit(Mutations.SET_PAYMENT_PROVIDERS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_UNIT_ORDERS(unitId: number) {
        axios.get(Endpoints.Admin.Finances.FETCH_UNIT_ORDERS(unitId))
            .then((response) => {
                store.commit(Mutations.SET_UNIT_ORDERS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_UNIT_REFUNDABLE_ORDERS(unitId: number) {
        axios.get(Endpoints.Admin.Finances.FETCH_UNIT_REFUNDABLE_ORDERS(unitId))
            .then((response) => {
                store.commit(Mutations.SET_UNIT_REFUNDABLE_ORDERS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }
}
